
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.717 2.305a.75.75 0 01.566 0l6.545 2.667a.75.75 0 01.376.336l1.454 2.666a.75.75 0 01-.36 1.048l-1.002.432v4.594a.75.75 0 01-.468.694l-6.545 2.667a.75.75 0 01-.566 0l-6.545-2.667a.75.75 0 01-.467-.694V9.43l-.988-.402a.75.75 0 01-.375-1.054l1.454-2.666a.75.75 0 01.376-.336l6.545-2.667zm-5.512 7.736v3.502L10 15.904l5.796-2.36V10.1l-3.68 1.588a.75.75 0 01-.918-.267L10.071 9.77l-.867 1.59a.75.75 0 01-.942.336L4.205 10.04zm6.938-1.363l5.065-2.064.74 1.356-4.859 2.096-.947-1.388zm3.415-3.011L10 7.523 5.442 5.667 10 3.81l4.558 1.857zm-10.766.947L3.06 7.955l5.148 2.098.732-1.342-5.148-2.097z","fill":"currentColor"}})])
          )
        }
      }
    